export const detectImage = src => new Promise((resolve, reject) => {
  const tester = new Image()
  const onLoad = () => {
    removeListeners()
    resolve()
  }
  const onError = () => {
    removeListeners()
    reject()
  }
  const removeListeners = () => {
    tester.removeEventListener('load', onLoad)
    tester.removeEventListener('error', onError)
  }

  tester.addEventListener('load', onLoad)
  tester.addEventListener('error', onError)
  tester.src = src
})

export const debounce = fn => {
  let scheduledAnimationFrame = false

  return (...args) => {
    if (scheduledAnimationFrame) {
      return
    }

    scheduledAnimationFrame = true
    requestAnimationFrame(() => {
      fn(...args)
      scheduledAnimationFrame = false
    })
  }
}
